import InputColorPicker from './InputColorPicker';

export default InputColorPicker;
